import { FadeUp, SectionHeading } from "../components/motion";

const SETTINGS = ["Hospice", "Healthcare", "Corporate", "Military", "Public Safety", "Community", "Other settings"];

const WAKE_IMG = "https://images.unsplash.com/photo-1565192483566-5cbbe39a76d2?q=80&w=1600&auto=format&fit=crop";

export default function Why() {
  return (
    <section id="why" data-testid="section-why" className="relative overflow-hidden bg-cream py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-10">
        <div className="lg:col-span-7">
          <SectionHeading
            tone="light-bg"
            eyebrow="Why Chaplain at Sea"
            titleLines={["Space for the one", "who holds space."]}
          />
          <FadeUp delay={0.2}>
            <p className="mt-10 max-w-2xl font-serif text-2xl font-light leading-snug text-navy sm:text-[1.7rem]" data-testid="why-lead">
              Chaplains spend their days making room for the stories, struggles, and spiritual needs
              of others. Chaplain at Sea creates space for your own renewal&mdash;with opportunities
              to rest, reconnect with your calling, explore your voice through writing, and enjoy
              the company of people who understand the work.
            </p>
          </FadeUp>
          <FadeUp delay={0.3}>
            <p className="mt-8 max-w-xl text-sm leading-relaxed text-navy/60" data-testid="why-optional-note">
              Spiritual activities are described clearly, and participation is always optional.
            </p>
          </FadeUp>
        </div>

        <div className="lg:col-span-5">
          <FadeUp delay={0.15} className="relative">
            <div className="absolute -left-3 -top-3 h-full w-full border border-gold/40" aria-hidden="true" />
            <div className="relative overflow-hidden">
              <img
                src={WAKE_IMG}
                alt="The wake of a ship stretching across deep blue water"
                className="aspect-[4/5] w-full object-cover transition-transform duration-[2.5s] hover:scale-105"
                loading="lazy"
                data-testid="why-image"
              />
            </div>
          </FadeUp>
          <FadeUp delay={0.3}>
            <div className="mt-8 border border-navy/10 bg-parchment p-7" data-testid="why-welcome-card">
              <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-gold">You are welcome here</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {SETTINGS.map((s) => (
                  <span key={s} className="border border-navy/15 bg-cream px-3 py-1.5 text-xs text-navy/80">
                    {s}
                  </span>
                ))}
              </div>
              <p className="mt-5 text-sm leading-relaxed text-navy/70">
                We welcome chaplains from hospice, healthcare, corporate, military, public safety,
                community, and other settings&mdash;and from different faith traditions and spiritual
                perspectives.
              </p>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
